import * as React from "react"
import "twin.macro"
import { graphql, Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

export default function MissionStatement() {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "homepage_about_bg.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <div tw="relative bg-white overflow-hidden">
      <div tw="max-w-screen-xl mx-auto">
        <div tw="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
          <svg
            tw="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>
          <main tw="pt-10 mx-auto max-w-screen-xl px-4 sm:pt-12 sm:px-6 md:pt-16 lg:pt-20 lg:px-8 xl:pt-28">
            <div tw="sm:text-center lg:text-left">
              <h2 tw="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
                Let's get down to <br tw="xl:hidden" />
                <span tw="text-blue-600">business.</span>
              </h2>
              <p tw="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                With alumni networks expanding from top schools like Stanford, MIT, 
                and University of Pennsylvania’s Wharton School of Business to 
                notable companies Ebay, Goldman Sachs, and self-founded startups,
                We are committed to empowering high school students and teaching
                them the skills necessary to succeed in the professional world.
              </p>
              <div tw="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                <div>
                  <Link
                    to="/about"
                    tw="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-blue-700 bg-blue-100 hover:text-blue-600 hover:bg-blue-50 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                  >
                    Learn More About Us
                  </Link>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div tw="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <Img
          tw="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
          fluid={data.file.childImageSharp.fluid}
        />
      </div>
    </div>
  )
}
